<div class="base-container logbook-main-container">
  <div class="panel logbook-filter-panel">
    <!-- Neu-Button -->
    <button
      mat-flat-button
      class="btn-logbook-new"
      routerLink="/operation-report-edit"
      (click)="onQueryData()">
      <fa-icon [icon]="['far', 'plus']"></fa-icon> &nbsp;
      {{ 'PRODUCT.OPREPORT.NEW' | translate }}
    </button>
    <span class="navbar-spacer"></span>

    <!-- Status-Filter -->
    <mat-form-field
      appearance="fill"
      class="logbook-status-field"
      subscriptSizing="dynamic">
      <mat-label>{{ 'PRODUCT.OPREPORT.STATUS' | translate }}</mat-label>
      <mat-select
        [value]="statusFilter()"
        (selectionChange)="statusFilter.set($event.value)">
        <mat-option value="all">
          {{ 'PRODUCT.OPREPORT.EDIT.STATUS_ALL' | translate }}
        </mat-option>
        <mat-option value="open">
          {{ 'PRODUCT.OPREPORT.EDIT.STATUS_OPEN' | translate }}
        </mat-option>
        <mat-option value="closed">
          {{ 'PRODUCT.OPREPORT.EDIT.STATUS_CLOSED' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Kategorie-Filter -->
    <mat-form-field
      appearance="fill"
      class="logbook-category-field"
      subscriptSizing="dynamic">
      <mat-label>{{ 'PRODUCT.OPREPORT.CATEGORY' | translate }}</mat-label>
      <mat-select
        multiple
        [value]="activeCategoryFilter()"
        (selectionChange)="onCategoryFilterChange($event.value)">
        <mat-option [value]="ALL_CATEGORIES_VALUE">
          {{ 'PRODUCT.OPREPORT.EDIT.CATEGORY_SELECT_ALL' | translate }}
        </mat-option>
        <mat-option [value]="NO_CATEGORIES_VALUE">
          {{ 'PRODUCT.OPREPORT.EDIT.CATEGORY_SELECT_NONE' | translate }}
        </mat-option>
        @for (category of availableCategories(); track category.key) {
          <mat-option [value]="category.key">
            {{ categoryLabel(category.key) | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <span class="logbook-filter-divider"></span>

    <!-- Zeitraums-Eingabe (MDC Date Range Input) -->
    <mat-form-field
      appearance="fill"
      class="logbook-range-field"
      (click)="picker.open()"
      subscriptSizing="dynamic">
      <mat-label>{{
        'PRODUCT.SMW.ARCHIVE.SELECT_TIME_RANGE' | translate
      }}</mat-label>
      <mat-date-range-input
        [formGroup]="dateRange"
        [rangePicker]="picker"
        [dateFilter]="dateFilter"
        class="logbook-range-inputs">
        <input
          matStartDate
          formControlName="start"
          placeholder="Startdatum"
          class="logbook-input-element" />
        <input
          matEndDate
          formControlName="end"
          placeholder="Enddatum"
          class="logbook-input-element" />
      </mat-date-range-input>

      <mat-datepicker-toggle matSuffix [for]="picker">
        <fa-icon
          matDatepickerToggleIcon
          [icon]="['far', 'calendar-alt']"
          transform="up-1 shrink-2"
          size="lg"></fa-icon>
      </mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- Validierungsfehler -->
    <div class="logbook-validation-errors">
      @if (startHasMatError()) {
        <mat-error>Invalid start date</mat-error>
      } @else if (endHasMatError()) {
        <mat-error>Invalid end date</mat-error>
      }
      @if (startHasMatRequiredError()) {
        <mat-error>Start date is required</mat-error>
      } @else if (endHasMatRequiredError()) {
        <mat-error>End date is required</mat-error>
      }
    </div>

    <!-- Abfrage-Button -->
    <button
      mat-flat-button
      color="primary"
      class="btn-logbook-query"
      (click)="onQueryData()"
      [disabled]="dateRangeInvalid()">
      <fa-icon [icon]="['far', 'th']"></fa-icon> &nbsp;
      {{ 'PRODUCT.SMW.ARCHIVE.QUERY_DATA' | translate }}
    </button>
  </div>

  <!-- 2. LOGBUCH DATEN-TABELLE (Eingebettet in Milchglas-Card) -->
  @let reportsValue = filteredReports();
  @if (reportsValue) {
    <mat-card
      appearance="outlined"
      class="table-card smw-table-container logbook-data-card">
      <div class="logbook-table-scroll-wrapper">
        <table class="logbook-native-table">
          <thead>
            <tr class="logbook-header-row">
              <th class="col-contact">
                {{ 'PRODUCT.OPREPORT.START' | translate }}
              </th>
              <th class="col-contact">
                {{ 'PRODUCT.OPREPORT.CLOSED' | translate }}
              </th>
              <th class="col-contact">
                {{ 'PRODUCT.OPREPORT.STATUS' | translate }}
              </th>
              <th class="col-author">
                {{ 'PRODUCT.OPREPORT.AUTHOR' | translate }}
              </th>
              <th class="col-subject">
                {{ 'PRODUCT.OPREPORT.CATEGORY' | translate }}
              </th>
              <th class="col-text">
                {{ 'PRODUCT.OPREPORT.SITUATION' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (report of reportsValue; track report.id) {
              <tr
                class="logbook-body-row logbook-body-row--clickable"
                [routerLink]="['/operation-report-edit']"
                [queryParams]="{ mode: editModeFor(report), id: report.id }">
                <!-- Spalte 1: Datum & Uhrzeit -->
                <td class="cell-dtg">
                  <div class="logbook-date-string">
                    <span class="date-main">
                      {{
                        report.start
                          | datex
                            : 'DD.MM.YYYY'
                            : undefined
                            : languageService.langSignal()
                      }}
                    </span>
                    <span class="time-sub">
                      {{
                        report.start
                          | datex
                            : 'HH:mm'
                            : undefined
                            : languageService.langSignal()
                      }}
                    </span>
                  </div>
                </td>
                <td class="cell-dtg">
                  <div class="logbook-date-string">
                    <span class="date-main">
                      {{
                        report.end
                          | datex
                            : 'DD.MM.YYYY'
                            : undefined
                            : languageService.langSignal()
                      }}
                    </span>
                    <span class="time-sub">
                      {{
                        report.end
                          | datex
                            : 'HH:mm'
                            : undefined
                            : languageService.langSignal()
                      }}
                    </span>
                  </div>
                </td>

                <!-- Spalte 2: Status -->
                <td class="cell-contact">
                  <span
                    class="logbook-badge-info"
                    [class.logbook-badge-info--open]="
                      report.content.status === 'open'
                    "
                    [class.logbook-badge-info--closed]="
                      report.content.status === 'closed'
                    ">
                    {{
                      (report.content.status === 'open'
                        ? 'PRODUCT.OPREPORT.EDIT.STATUS_OPEN'
                        : 'PRODUCT.OPREPORT.EDIT.STATUS_CLOSED'
                      ) | translate
                    }}
                  </span>
                </td>

                <!-- Spalte 3: Einsatzleiter -->
                <td class="cell-author">
                  <strong>{{ report.content.leaderName }}</strong>
                </td>

                <!-- Spalte 4: Kategorien -->
                <td class="cell-subject">
                  <div class="subject-category-list">
                    @for (category of report.content.categories; track $index) {
                      @let colorSet = categoryColorSet(category);
                      <span
                        class="subject-text-highlight"
                        [style.background]="colorSet.background"
                        [style.color]="colorSet.color"
                        [style.border-color]="colorSet.border">
                        {{ categoryLabel(category.key) | translate }}
                      </span>
                    }
                  </div>
                </td>

                <!-- Spalte 5: Lagebericht (Aufgeteilt nach Zeilenumbrüchen) -->
                <td class="cell-text">
                  <div class="logbook-message-paragraph-box">
                    @for (
                      line of (report.content.situationReport || '').split(
                        '\n'
                      );
                      track $index
                    ) {
                      <p class="logbook-message-line">
                        {{ line }}
                      </p>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </mat-card>
  }
</div>
